module.exports = window.__GLOBAL_VAR__||{};